import { render, staticRenderFns } from "./ContactClue.vue?vue&type=template&id=89b0f322&scoped=true&"
import script from "./ContactClue.vue?vue&type=script&lang=js&"
export * from "./ContactClue.vue?vue&type=script&lang=js&"
import style0 from "./ContactClue.vue?vue&type=style&index=0&id=89b0f322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b0f322",
  null
  
)

export default component.exports